<div *ngIf="agentMode" class="govuk-width-container">
	<button type="button" class="btn btn-primary" data-module="govuk-button" (click)="datastoreService?.agentRestart()">
		Agent Restart
	</button>
</div>

<main>
	<div class="row">
		<div class="col-12">
			<gb-ui-page-heading
				[titleText]="'Booking confirmation'"
				bannerType="success"
			>
				<ng-template #subContent>
					<div class="sub-content">
						<p>{{ 'CONFIRMATION.REFERENCE_TEXT' | translate }}</p>
						<p class="booking-ref">
							{{ bookingNumber }}
						</p>
					</div>
				</ng-template>
			</gb-ui-page-heading>
		</div>
	</div>

	<div class="govuk-width-container">
		<div class="govuk-grid-row">
			<div class="govuk-grid-column-full">
				<h2>Booking Details:</h2>

				<div class="notification">
					<i class="ph ph-envelope-open" aria-hidden="true"></i>
					<span>Your full booking details will be sent in an email confirmation soon.</span>
				</div>
				<div class="notification">
					<i class="ph-fill ph-info" aria-hidden="true"></i>
					<span>Please check your junk/ spam folder if you do not receive the email.</span>
				</div>

				<div class="govuk-summary-card">
					<div class="govuk-summary-card__title-wrapper">
						<h3 class="govuk-summary-card__title">
							{{ 'COMMON.BOOKING' | translate }}
						</h3>
					</div>

					<div class="govuk-summary-card__content">
						<dl class="govuk-summary-list">
							<div class="govuk-summary-list__row">
								<dt class="govuk-summary-list__key">
									{{ 'COMMON.SERVICE' | translate }}
								</dt>
								<dd class="govuk-summary-list__value">
									{{ selectedService?.name }}
								</dd>
							</div>
							<div class="govuk-summary-list__row">
								<dt class="govuk-summary-list__key">Venue</dt>
								<dd class="govuk-summary-list__value">
									{{ selectedResourceObj?.name }}
								</dd>
							</div>
						</dl>
					</div>
				</div>

				<div class="govuk-summary-card">
					<div class="govuk-summary-card__title-wrapper">
						<h3 class="govuk-summary-card__title">
							{{ 'COMMON.DATE_TIME' | translate }}
						</h3>
					</div>
					<div class="govuk-summary-card__content">
						<dl class="govuk-summary-list">
							<div class="govuk-summary-list__row">
								<dt class="govuk-summary-list__key">
									{{ 'COMMON.DATE' | translate }}
								</dt>
								<dd class="govuk-summary-list__value">
									{{
										selectedSlot?.start
											| date
												: 'EEEE d MMMM yyyy'
												: ''
												: translateService.currentLang
									}}
								</dd>
							</div>

							<div class="govuk-summary-list__row">
								<dt class="govuk-summary-list__key">
									{{ 'COMMON.TIME' | translate }}
								</dt>
								<dd class="govuk-summary-list__value">
									{{ selectedSlot?.displayTime }}
								</dd>
							</div>
						</dl>
					</div>
				</div>

				<div class="govuk-summary-card">
					<div class="govuk-summary-card__title-wrapper">
						<h3 class="govuk-summary-card__title">
							{{ 'COMMON.PATIENT_DETAILS' | translate }}
						</h3>
					</div>
					<div class="govuk-summary-card__content">
						<dl class="govuk-summary-list">
							<div class="govuk-summary-list__row">
								<dt class="govuk-summary-list__key">
									{{ 'COMMON.NAME' | translate }}
								</dt>
								<dd class="govuk-summary-list__value">
									{{ client?.first_name }} {{ client?.last_name }}
								</dd>
							</div>

							<div class="govuk-summary-list__row">
								<dt class="govuk-summary-list__key">
									{{ 'COMMON.EMAIL_ADDRESS' | translate }}
								</dt>
								<dd class="govuk-summary-list__value">
									{{ datastoreService?.booking?.email }}
								</dd>
							</div>

							<div
								class="govuk-summary-list__row"
								*ngIf="client?.mobile_number"
							>
								<dt class="govuk-summary-list__key">
									{{ 'COMMON.MOBILE_NUMBER' | translate }}
								</dt>
								<dd class="govuk-summary-list__value">
									{{ selectedSlot?.mobile_number }}
								</dd>
							</div>

							<div class="govuk-summary-list__row" *ngIf="client?.postcode">
								<dt class="govuk-summary-list__key">
									{{ 'COMMON.POSTNAME' | translate }}
								</dt>
								<dd class="govuk-summary-list__value">
									{{ selectedSlot?.postcode }}
								</dd>
							</div>
						</dl>
					</div>
				</div>

				<!-- <div class="govuk-summary-card">
			<div class="govuk-summary-card__title-wrapper">
				<h2 class="govuk-summary-card__title">
					{{'COMMON.BOOKING_DETAILS' | translate}}
				</h2>
			</div>
			<div class="govuk-summary-card__content">
				<dl class="govuk-summary-list" *ngFor="let detail of bookingSummaryData">
					<div class="govuk-summary-list__row">
						<dt class="govuk-summary-list__key">
							{{ detail.name | translateSplit }}
						</dt>
						<dd class="govuk-summary-list__value">
							{{ detail.answer }}
						</dd>
					</div>
				</dl>
			</div>
		</div> -->
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<button
					type="submit"
					class="btn btn-outline-primary"
					(click)="print()"
					aria-label="print your booking details"
				>
					{{ 'COMMON.PRINT' | translate }}
				</button>
				<button
					*ngIf="!adminMode && showLoginButton"
					type="submit"
					class="btn btn-outline-primary"
					(click)="goToLogin()"
				>
					{{ 'COMMON.LOGIN_TO_CEREMONY' | translate }}
				</button>
			</div>
			
		</div>
	</div>
</main>